import { TextField } from '@fluentui/react';
import { useEffect, useState } from 'react';
import './InputWithValidator.css';

interface IInputWithValidatorProps {
    validator: (value: string) => boolean;
    errorMessage: string;
    inputValue: string;
    onValueChange: (value: string, hasError: boolean) => void;
    placeholder?: string;
}

export default function InputWithValidator(props: IInputWithValidatorProps) {
    const [showError, setShowError] = useState<boolean>(false);

    useEffect(() => {
        const validResult = props.validator(props.inputValue);
        setShowError(!validResult);
    }, [props.inputValue]);

    const handleInputChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ) => {
        const value = newValue || '';
        const validResult = props.validator(value);
        props.onValueChange(value, !validResult);
        setShowError(!validResult);
    };

    return (
        <div className="valid_input_container">
            <TextField
                value={props.inputValue}
                onChange={handleInputChange}
                placeholder={props.placeholder}
                errorMessage={showError ? props.errorMessage : ''}
                className="valid_input_text"
            />
        </div>
    );
}
